import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const RightTable = ({ tableRightList, loading, onAmountChange, onRefNoChange }) => {
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const selectedAmount = selectedRow ? Number(selectedRow.AMOUNT) : 0;
    onAmountChange?.(selectedAmount);
    const selectedRefNo = selectedRow?.TR_SLNO || null;
    onRefNoChange?.(selectedRefNo);
  }, [selectedRow]);

  return (
    <div className="h-[40vh] w-full overflow-auto">
      <h2 className="text-md text-gray-800 mt-2 mb-1">On Account</h2>

      <table className="relative text-xs border-collapse w-full">
        <thead>
          <tr>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Select
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Type
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Type No
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Amount
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Ref
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              JV Date
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Entry Ref
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              TR Sl No
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              Job Code
            </th>
            <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
              JV Type
            </th>
          </tr>
        </thead>

        <tbody>
          {loading ? (
            <tr>
              <td colSpan={10} className="py-6 text-center">
                <div className="flex items-center justify-center gap-2 text-gray-600">
                  <span className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></span>
                  Loading data...
                </div>
              </td>
            </tr>
          ) : tableRightList?.length > 0 ? (
            tableRightList.map((row, index) => (
              <tr key={index} className="text-xs">
                <td className="border w-24 bg-white text-center">
                  <input
                    type="radio"
                    name="rightTableRow"
                    checked={selectedRow?.TR_SLNO === row?.TR_SLNO}
                    onChange={() => setSelectedRow(row)}
                  />
                </td>
                <td
                  className={`border px-2 py-1 text-center ${
                    row?.TYPE === "C"
                      ? "bg-red-500 text-white"
                      : "bg-green-500 text-white"
                  }`}
                >
                  {row?.TYPE ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-right">
                  {row?.type_no ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-right">
                  {row?.AMOUNT ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.REF ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left cursor-pointer">
                  {row?.JVDATE ? dayjs(row.JVDATE).format("DD/MM/YYYY") : "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.ENTRY_REF ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-right">
                  {row?.TR_SLNO ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.job_code ?? "-"}
                </td>
                <td className="border bg-white px-2 py-1 text-left">
                  {row?.JVTYPE ?? "-"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={10} className="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RightTable;
